/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import styled from "styled-components";
import Spinner from "react-bootstrap/Spinner";

import ViewCompanyDetailHeader from "../ViewCompanyDetailHeader";
import SpendSection from "../SpendSection";
import CompanyDetail from "../CompanyDetail";
import ContactSection from "../../../../admin/companies/components/ContactSection";

import { viewCompany } from "../../../../admin/companies/companySlice";

export default function ExploreFlyoutCompanyProfile(props) {
    const dispatch = useDispatch();

    const [company, setCompany] = useState(null);
    const companyState = useSelector(state => state.adminCompany);

    useEffect(() => {
        if (props.companyId) {
            // console.log('Here my id', props.companyId);
            dispatch(viewCompany({id: props.companyId}));
        }
    }, [props.companyId]);

    useEffect(() => {
        if (companyState.viewCompany) {
            setCompany(companyState.viewCompany);
        } else {
            setCompany(null);
        }
    }, [companyState.viewCompany]);

    const companyMock = {
        "id":"107372a4-27ed-4143-a64d-13d7c5a76e87",
        "identity":"182d0240-57f9-4b22-ac10-32926f40e565",
        "score":0.9555,
        "name":"One Call Services Inc",
        "overview":null,
        "logo":null,
        "url":"onecallservices.biz",
        "urlVerified":true,
        "addressDeliveryLine1":"32477 Lewes Georgetown Hwy",
        "addressCity":"Lewes",
        "addressRegion":"DE",
        "addressPostalCode":"19958",
        "addressLocMsa":"Salisbury, MD-DE",
        "phone":"(302) 645-9008",
        "primaryTrade":"General Contractor",
        "trades":"General Contractor",
        "services":"Construction, Finish Carpentry, Kitchen and Bath Remodeling, Residential Construction, Roofing, Kitchen Remodeling, Bathroom Remodeling, Repair and Remodel, Flooring, Home Builder, Handyman Services, Design, Decking",
        "affinities":"Wolfe Home Products, TimberTech",
        "affiliations":"National Kitchen and Bath Association (NKBA), Claims Pages, National Association of Home Builders (NAHB), National Association of Home Builders (NAHB) - Professional Remodelers, Builders and Remodelers Association of Delaware, National Association of Home Builders (NAHB) -Pro Certifications",
        "facts":{
            "founded":"2006"
        },
        "indicators":{
            "markets":"Residential, Commercial"
        },
        "statistics":{
            "employeesRange":"B:5-9",
            "salesRange":"C:1M-2M"
        },
        "licenses":{
            "licenses":null,
            "licensesWSource":null,
            "licensesWRegion":null
        },
        "permits":{
            "cnt":154,
            "cntYearToDate":null,
            "cntLastYear":10,
            "cntYearBeforeLast":22
        },
        "activity":{
            "jobStarts":null,
            "jobStartsYearToDate":null,
            "jobStartsLastYear":null,
            "jobStartsYearBeforeLast":null,
            "activeJobStarts":null,
            "jobProjectTypes":null,
            "jobPriceMin":null,
            "jobPriceMax":null,
            "jobPriceAvg":null,
            "categorySpend":null,
            "categorySpendYearToDate":null,
            "categorySpendLastYear":null,
            "categorySpendYearBeforeLast":null,
            "productCategorySpend":null,
            "productCategorySpendYearToDate":null,
            "productCategorySpendLastYear":null,
            "productCategorySpendYearBeforeLast":null
        },
        "insights":{
            "marketsHighlight":null,
            "projectsHighlight":null,
            "typicalProjectValueHighlight":null,
            "servicesHighlight":null,
            "profileHighlight":null,
            "licenseHighlight":null,
            "permitHighlight":null,
            "policyHighlight":null,
            "affinitiesHighlight":null,
            "affiliationsHighlight":null,
            "activityHighlight":null
        },
        "primaryContact":{
            "id":"a7ae1909-acc6-4e24-9e39-8b75fe7c1175",
            "identity":"488df8e4-51ea-4975-a944-947895f317ac",
            "givenName":"James",
            "surname":"Stevenson",
            "title":"President",
            "phone":"(302) 645-9008",
            "email":"james@onecallservices.biz",
            "emailVerified":false
        },
        "secondaryContact":{
            "id":null,
            "identity":null,
            "givenName":null,
            "surname":null,
            "title":null,
            "phone":null,
            "email":null,
            "emailVerified":null
        }
    };

    if (companyState.loading) return (
        <Row>
            <Col>
                <div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <Spinner
                            style={{marginTop: '30px'}}
                            as="span"
                            animation="border"
                            role="status"
                            aria-hidden="true"
                            variant="info"
                        />
                    </div>
                </div>
            </Col>
        </Row>
    );

    return (
        <MainContainer>
            {company ? (
                <Row>
                    <Col xl={12} lg={12} md={12} sm={12}>
                        <ViewCompanyDetailHeader company={company} />
                        <SpendSection company={company} />
                        <CompanyDetail company={company} />
                        { company.primaryContact && company.primaryContact.givenName && (
                            <ContactSection
                                contactName={`${company.primaryContact.givenName || ''} ${company.primaryContact.surname || ''}`}
                                contactPhone={company.primaryContact.phone}
                                contactEmail={company.primaryContact.email}
                                contactTitle={company.primaryContact.title}
                                contactEmailStatus={company.primaryContact.emailVerified}
                            />
                        )}
                        { company.secondaryContact && company.secondaryContact.givenName && (
                            <ContactSection
                                contactName={`${company.secondaryContact.givenName || ''} ${company.secondaryContact.surname || ''}`}
                                contactPhone={company.secondaryContact.phone}
                                contactEmail={company.secondaryContact.email}
                                contactTitle={company.secondaryContact.title}
                                contactEmailStatus={company.secondaryContact.emailVerified}
                            />
                        )}
                    </Col>
                </Row>
            ) : (
                <Row>
                    <Col xl={12} lg={12} md={12} sm={12}>
                        Unable to retrieve a company profile information.
                    </Col>
                </Row>
            )}
        </MainContainer>
    );
}

const MainContainer = styled.div`
    width: 100%;
    max-width: 600px;
  
    margin-bottom: 20px;

    max-height: calc(100vh - 320px);
    overflow-x: hidden;
    overflow-y: auto;
`;

const InsightsSection = styled.div`
    margin: 20px;
`;
